import { format } from 'date-fns'
import { VITE_OLYMPIADS_PATH_TO_FILES } from '../constants/constants'
import { IOlympiadsStatistic } from './interfaces'
import FileService from './FileService'

export abstract class OlympiadsFileService extends FileService implements IOlympiadsStatistic {
    protected olympiadsPathToFiles: string
    protected ts = format(new Date(), 'yyyy.M.d')

    constructor(olympiadsPathToFiles: string) {
        super()
        this.olympiadsPathToFiles = olympiadsPathToFiles
    }

    abstract getOlympiadStatisticRegionFile(olympiadId: string, level: string, region: string): Promise<ArrayBuffer | null>
    abstract getOlympiadStatisticRussiaFile(olympiadId: string, level: string): Promise<ArrayBuffer | null>
    abstract getPathRegion(olympiadId: string, level: string, region: string): string | null
    abstract getPathRussia(olympiadId: string, level: string): string | null
}

// year after 2026
export class OlympiadsFileServiceRegions extends OlympiadsFileService {
    constructor() {
        super(`${VITE_OLYMPIADS_PATH_TO_FILES}/olympiads_data`)
    }

    public getPathRegion(olympiadId: string, level: string, region: string): string | null {
        return `${this.olympiadsPathToFiles}/${olympiadId}/Cabmun/${level}/${region}.xlsx?ts=${this.ts}`
    }

    public getPathRussia(olympiadId: string, level: string): string | null {
        return `${this.olympiadsPathToFiles}/${olympiadId}/Cabmun/All/${level}.xlsx?ts=${this.ts}`
    }

    public async getOlympiadStatisticRegionFile(olympiadId: string, level: string, region: string): Promise<ArrayBuffer | null> {
        const path = this.getPathRegion(olympiadId, level, region)
        return this.fetchFile(path!)
    }

    public async getOlympiadStatisticRussiaFile(olympiadId: string, level: string): Promise<ArrayBuffer | null> {
        const path = this.getPathRussia(olympiadId, level)
        return this.fetchFile(path!)
    }

}

// deprecated: year <= 2026
export class OlympiadsFileServiceRussia extends OlympiadsFileService {
    constructor() {
        super(`${VITE_OLYMPIADS_PATH_TO_FILES}/olympiads-mini-app`)
    }

    public getPathRussia(olympiadId: string, level: string): string | null {
        return `${this.olympiadsPathToFiles}/${olympiadId}/${level}.xlsx?ts=${this.ts}`
    }

    public getPathRegion(_olympiadId: string, _level: string, _region: string): null {
        return null
    }

    public async getOlympiadStatisticRussiaFile(olympiadId: string, level: string): Promise<ArrayBuffer | null> {
        const path = this.getPathRussia(olympiadId, level)
        return this.fetchFile(path!)
    }

    public async getOlympiadStatisticRegionFile(_olympiadId: string, _level: string, _region: string): Promise<ArrayBuffer | null> {
        return this.getPathRegion(_olympiadId, _level, _region)
    }
}

export const getOlympiadsFileService = (years: number[]): OlympiadsFileService | null => {
    if (years.length < 2) return null
    const [startYear, endYear] = years

    if (startYear >= 2024 && endYear <= 2026) {
        return new OlympiadsFileServiceRussia()
    } else if (startYear >= 2026 && endYear >= 2027) {
        return new OlympiadsFileServiceRegions()
    }

    return null
}

